module.exports = __webpack_public_path__ + "static/img/3d_top2.e9d0887.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/3Dmodeling/3d_top2.png
// module id = YSFC
// module chunks = 1